var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomCircular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9609 7.33337C13.6529 4.55271 11.4469 2.34737 8.66685 2.03937M8.66659 13.961C11.4473 13.653 13.6526 11.447 13.9606 8.66697M2.03899 8.66671C2.34699 11.4474 4.55298 13.6527 7.33299 13.9607M7.33325 2.03911C4.55259 2.34711 2.34659 4.55311 2.03925 7.33311M7.33325 14.6667H8.66659V13.3334H7.33325V14.6667ZM7.33325 2.66671H8.66659V1.33337H7.33325V2.66671ZM7.33325 8.66671H8.66659V7.33337H7.33325V8.66671ZM13.3333 8.66671H14.6666V7.33337H13.3333V8.66671ZM1.33325 8.66671H2.66659V7.33337H1.33325V8.66671Z",
    stroke: "#646D7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCircular);
export default __webpack_public_path__ + "static/media/custom-circular.0951725c34a12c269f661050b34c4917.svg";
export { ForwardRef as ReactComponent };